import styled from '@mui/material/styles/styled';

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${(p) => p.theme.spacing(3)};
  padding-left: 0;
`;

export const SnackBarContainer = styled('div')`
  position: relative;

  & .snackBarBlock {
    position: fixed;
    left: 50%;
    bottom: 15px;
    transform: translate(-50%);
  }
`;

export const EmptyStateContainer = styled('div')`
  display: inline-flex;
  align-items: center;
  column-gap: 5px;
  padding: 25px;
  padding-left: 0;
`;
